import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=5cabc13c&scoped=true&"
import script from "./RightDrawer.vue?vue&type=script&lang=js&"
export * from "./RightDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=5cabc13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabc13c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VNavigationDrawer})
